import * as types from './index';

export const feedbackListAction =(data) =>{ 
    return {
        type: types.FEEDBACK_LIST,
        data
    }
}

export const feedbackDetailsAction =(data) =>{ 
    return {
        type: types.FEEDBACK_DETAILS,
        data
    }
}

export const feedbackUpdateAction =(data) =>{ 
    return {
        type: types.FEEDBACK_UPDATE,
        data
    }
}

export const feedbackStarRatingAction =(data) =>{ 
    return {
        type: types.FEEDBACK_STAR_RATING,
        data
    }
}

export const actionTakenShiftGetAction =(data) =>{ 
    return {
        type: types.ACTION_TAKEN_SHIFT,
        data
    }
}

export const actionTakenShiftUpdateAction =(data) =>{ 
    return {
        type: types.ACTION_TAKEN_SHIFT_UPDATE,
        data
    }
} 

export const actionTakenCrewGetAction =(data) =>{ 
    return {
        type: types.ACTION_TAKEN_CREW,
        data
    }
}

export const actionTakenCrewUpdateAction =(data) =>{ 
    return {
        type: types.ACTION_TAKEN_CREW_UPDATE,
        data
    }
}